import { Capacitor } from '@capacitor/core'
export enum Device {
  Windows = 'windows',
  WindowsPhone = 'windows_phone',
  Android = 'android',
  IOS = 'ios',
  Unknown = 'unknown',
}

export const useDevice = () => {
  function getPlatform() {
    const userAgent = process.server
      ? useRequestHeaders()['user-agent']
      : navigator.userAgent || navigator.vendor

    if (/Windows NT/i.test(userAgent)) {
      return Device.Windows
    }

    if (/windows phone/i.test(userAgent)) {
      return Device.WindowsPhone
    }

    if (/android/i.test(userAgent)) {
      return Device.Android
    }

    if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      // @ts-ignore-next-line
      (process.client ? !window.MSStream : true)
    ) {
      return Device.IOS
    }

    return Device.Unknown
  }

  const platform = Capacitor.isNativePlatform()
    ? Capacitor.getPlatform()
    : getPlatform()

  const isMobile = platform === Device.IOS || platform === Device.Android
  return {
    isMobile,
    platform,
  }
}
